<template>
    <el-dialog
        :loading="loading"
        :visible.sync="visible"
        width="600px"
        center
        @closed="closed"
    >
        <template v-slot:title>
            修改<span style="color: #33B3FF">{{ name }}</span>的拉新提成设置
        </template>
        <el-form :class="[prefix]" label-position="right" label-width="120px">
            <el-form-item label="提成比例">
                <span class="w-label">拉新好友项目收益</span>
                <el-input-number
                    :min="0"
                    :max="20"
                    v-inputLimit:int="{ min: 0 }"
                    type="number"
                    v-model="pullNewForm.commissionPercent"
                ></el-input-number>
                <span class="w-right-label">%</span>
            </el-form-item>
            <el-form-item label="提成有效期">
                <span class="w-label">首次收益提成到账</span>
                <el-input-number :min="1" type="number" v-model="pullNewForm.commissionExpireTime"></el-input-number>
                <span class="w-right-label">天后过期</span>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="modifyPullNewSet">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { verifyField } from "@/common/utils";

const prefix = 'w-pull-new-set-dialog'

export default {
    props: {
        value: Boolean,
        openId: String,
        name: String,
        commissionPercent: {
            type: [ String, Number ],
            default: ''
        },
        commissionExpireTime: {
            type: [ String, Number ],
            default: ''
        }
    },
    data() {
        return {
            prefix,
            visible: false,
            loading: false,
            pullNewForm: {},
            verifyRules: {
                commissionPercent: [
                    { required: true, message: "请输入拉新好友项目收益比例" },
                ],
                commissionExpireTime: [
                    {
                        required: true,
                        message: "请输入首次收益提成到账过期天数",
                    },
                ],
            },
        };
    },
    methods: {
        async modifyPullNewSet() {
            if (verifyField(this.verifyRules, this.pullNewForm)) {
                this.loading = true;
                try {
                    await this.api.vipBehaviorReward(
                        Object.assign(this.pullNewForm, {
                            accessToken: localStorage.getItem("access_token"),
                            openId: this.openId,
                        })
                    );
                    this.$message({ type: "success", message: "修改成功" });

                    this.$emit("modifyPullNewSet");
                    this.$emit("input", false);
                } finally {
                    this.loading = false;
                }
            }
        },
        closed() {
            this.$emit("input", false);
        },
    },
    watch: {
        value: {
            handler(val) {
                this.visible = val;

                // 2265 运营后台-用户基本信息列表修改用户拉新提成设置，修改信息后点击取消，页面没有恢复默认设置
                if(val) {
                    this.pullNewForm.commissionPercent = this.commissionPercent
                    this.pullNewForm.commissionExpireTime = this.commissionExpireTime
                }
            },
            immediate: true,
        },
        commissionPercent: {
            handler(val) {
                this.pullNewForm.commissionPercent = val
            },
            immediate: true
        },
        commissionExpireTime: {
            handler(val) {
                this.pullNewForm.commissionExpireTime = val
            },
            immediate: true
        }
    },
};
</script>

<style lang="scss">
$prefixCls: 'w-pull-new-set-dialog';

.#{$prefixCls} {
    .w-label {
        margin-right: 8px;
        color: #606266;
    }
    .w-right-label {
        margin-left: 8px;
        color: #606266;
    }
}
</style>